import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
} from "reactstrap";
import { postRouteConfig } from "../../../helpers/backend_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import NibbleInput from "../../../components/Fields/NibbleInput";

const ConfigModal = ({
  modal,
  setModal,
  completeHandler,
  horarioVelada,
  setHorarioVelada,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModal({ ...modal, show: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      horarioVelada,
    },
    validationSchema: Yup.object({
      horarioVelada: Yup.string().required("Requerido"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      await save(values);
      setLoading(false);
    },
  });

  const save = async (values) => {
    const response = await postRouteConfig({
      25: values.horarioVelada,
    });

    setHorarioVelada(response.filter((e) => e.configuration_id == 25)[0].value);

    if (completeHandler) completeHandler();
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          Configurar horario de velada
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <NibbleInput
                md={12}
                label="Hora de inicio velada:"
                fieldName="horarioVelada"
                fieldType="time"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cerrar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ConfigModal;
